const _ = require("lodash");
const channels = require("./app__channels").channels;
const googlDisplay = _.find(channels, { channel_short_name: "google-display" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const linkedin = _.find(channels, { channel_short_name: "linkedin" });
const twitter = _.find(channels, { channel_short_name: "twitter" });
const reddit = _.find(channels, { channel_short_name: "reddit" });
const youtube = _.find(channels, { channel_short_name: "youtube" });
const indeed = _.find(channels, { channel_short_name: "indeed" });

module.exports = [
  {
    budget: 200,
    minClicks: 10,
    name: "LinkedIn Einzelschaltung",
    id: "phrase--linkedin",
    nameShort: "A",
    description: "30 Tage Laufzeit / LinkedIn",
    color: "#B0D59D",
    selectedChannels: [linkedin]
  },
  {
    budget: 600,
    minClicks: 250,
    name: "Reddit & Twitter Einzelschaltung (IT Jobs)",
    id: "phrase--reddit-twitter",
    nameShort: "A",
    description: "30 Tage Laufzeit / Twitter & Reddit",
    color: "#B0D59D",
    selectedChannels: [reddit, twitter]
  },
  {
    budget: 600,
    minClicks: 400,
    name: "Marketing & Kaufmännische Jobs",
    id: "phrase--marketing",
    nameShort: "A",
    description: "30 Tage Laufzeit / YouTube, Google Display, Instagram",
    color: "#B0D59D",
    selectedChannels: [youtube, googlDisplay, instagram]
  },
  {
    budget: 400,
    minClicks: 10,
    name: "Indeed",
    id: "phrase--indeed",
    nameShort: "A",
    description: "30 Tage Laufzeit / Indeed",
    color: "#B0D59D",
    selectedChannels: [indeed]
  }
];
